import { render, staticRenderFns } from "./FacebookAdsTab.vue?vue&type=template&id=379f7340&scoped=true"
import script from "./FacebookAdsTab.vue?vue&type=script&lang=js"
export * from "./FacebookAdsTab.vue?vue&type=script&lang=js"
import style0 from "./FacebookAdsTab.vue?vue&type=style&index=0&id=379f7340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f7340",
  null
  
)

export default component.exports